<template>
    <div v-if="currentValue">
       <!-- 下拉选择弹框组建封装 开始 -->
        <transition name="ryt-transition">
            <div class="container ub ub-ver ub-ac2" v-if="touch_state < 2">
                <div>
                    <div class="close-block ub ub-ae" @click="btn_close()">
                    <img src="../../assets/img/关闭 (2).png" alt="">
                    </div>

                    <div class="ly-block">
                        <img v-if="touch_state==0" class="yuyin-0" src="../../assets/img/语音.png" alt="">
                        <div v-if="touch_state==1" class="yuyin-1 ub ub-ac ub-pc">
                            <div class="wave ub ub-ac ub-pc">
                                <img src="../../assets/img/new2024/voice_0.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                
                <div>
                    <div class="shuohua ub ub-ac ub-pc" v-if="touch_state == 0"><span>按住下方说话</span></div>
                    <div class="pin-block ub ub-ac" @touchstart.stop="startRecord" @touchend="stopRecord"></div>
                </div>
            </div>

            <div class="container ub ub-ver ub-ac2" v-if="touch_state == 2">
                <div>
                    <div class="close-block ub ub-ae" @click="btn_close()">
                    <img src="../../assets/img/关闭 (2).png" alt="">
                    </div>
                    <div class="yuyin-block ub ub-ver ub-ac ub-pc">
                        <div class="playVoice-block ub ub-ac ub-pc">
                            <div class="play-voice ub ub-ae ub-pc" @click="playVoice()">
                                <span>{{ time }}''</span>
                                <img v-if="play_voice_state == 0" class="trumpet" src="../../assets/img/new2024/audio_self.png" alt="">
                                <img v-if="play_voice_state == 1" class="trumpet" src="../../assets/img/new2024/audioPlay_self.gif" alt="">
                            </div>
                            <div class="play-voice-right"></div>
                        </div>
                        <span class="play-tip">点击播放语音</span>
                    </div>
                </div>
                
                <div class="btn-block ub ub-pc ub-ac1">
                    <div class="btn cancel ub ub-ac ub-pc" @click="btn_cancel()"><img src="../../assets/img/关闭 (2).png" alt=""></div>
                    <div class="btn send ub ub-ac ub-pc" @click="btn_send()"><img src="../../assets/img/radio.png" alt=""></div>
                    <!-- <div class="btn auto-send ub ub-ac ub-pc" v-if="send_state == 1" @click="stop_auto_send()"><img src="../../assets/img/顶0.png" alt=""></div> -->
                </div>

                <dlg ref="myForm_sendVoice" @formBehavior="formact_sendVoice"></dlg>
                <alert ref="myConfirm_buyCoin" @userBehavior="formact_buycoin"></alert>
            </div>
        </transition>

       <!-- 下拉选择弹框组建封装 结束 -->
       </div>
</template>

<script>
import * as tool from '../../api/common';
import { mapMutations, mapActions } from 'vuex';
import Form from "../../components/Form.vue";
import Alert from "../../components/Alert.vue";
   export default {
       name: "chatStartRecord",
       props: {
           center: { //接受父组件给子组件的center属性的传值
               type: Boolean,
               default: false
           },
           toUid: String,
       },
       components: {
            alert: Alert,
            dlg: Form,
        },
       data() {
           return {
               currentValue: false,
               touch_state: 0,
               send_state: 0,
               send_timeout: "",
               play_voice_state: 0,
               time: 0,
               startTime: 0,
               uinfo_from: {
                    photo: "",
                    nick: "",
                    sex: "",
                    age_range: "",
                    score_total: 0,
                    coin_total: 0,
                },
           }

       },
       watch: {
           center(val) { //监听父组件通过props传过来的center的布尔值打开子组件下拉框
               this.currentValue = val;
               this.reset();
               var self = this;
               var uid = this.$store.state.uid;
                self.act_get_userinfo({
                    uid: uid,
                    success: function (u) {
                    self.uinfo_from = u;
                    },
                });
           }

       },
       mounted() {
            this.init_page();
       },
       methods: {
        ...mapMutations(['get', 'post', "WxConfig", "wxStartRecord", "wxStopRecord", "wxPlayVoice", "wxUploadVoice", "wxOnVoicePlayEnd", "wxStopVoice", "wxPauseVoice"]), //引入方法
        ...mapActions(["act_get_userinfo","act_reload_userinfo","act_sub_coin"]), //引入方法
            init_page() {
                this.WxConfig({url:window.location.href});
            },

            startRecord() {
                this.$emit("reset_chat_wx");
                this.startTime = new Date();
                this.touch_state = 1;
                this.wxStartRecord();
                this.$store.commit('set_objVal', {"voice_state":1});
            },

            stopRecord() {
               this.$store.commit('set_objVal', {"voice_state":0});
               this.touch_state = 2;
               
               if(!this.check_record_time()){
                  return false;
               }
               
               var self = this;
               var data = {
                suc: function(res) {
                    self.localId = res.localId;
                }
               };
               this.wxStopRecord(data);

            //    //自动发送
            //    this.send_state = 1;
            //    var self = this;
            //    self.send_timeout = setTimeout(()=>{
            //     self.btn_send();
            //    },5000)
            },

            check_record_time() {
                var now = new Date();
                var mm = now.getTime() - this.startTime.getTime();
                if (mm < 2000) {
                    this.$toast.center("说话时间太短~");
                    this.reset();
                    return false;
                }
                //console.log(mm);
                this.time = Math.floor(mm /1000);
                return true;
            },
            
            playVoice() {
                //this.$toast.center("play_voice_state--->" + this.play_voice_state);
                //暂停播放
                if (this.play_voice_state == 1) {
                    this.play_voice_state = 0;
                    this.wxStopVoice(this.localId);
                    return true;
                }
                //播放
                if (this.play_voice_state == 0) {
                    this.play_voice_state = 1;
                    this.$store.commit('set_objVal', {"voice_state":2});
                    this.wxPlayVoice(this.localId);
                    var self = this;
                    var data = {
                        suc: function(res) {
                                if (res) {
                                    self.play_voice_state = 0;
                                }
                            }
                    }
                    this.wxOnVoicePlayEnd(data);
                }
            },

            btn_send() {
                //第一步：发送检测
                if(!this.localId || this.time < 1){
                    this.$toast.center("发送异常,请重新说话~");
                    this.reset();
                    return false;
                }
                //第二步，发送
                if (this.check_right()) {
                    this.do_send();
                }
            },
            do_send() {
                this.loading("发送中...",8000);
                //第一步：上传微信服务器，并发送消息
                var self = this;
                var localId = this.localId;
                var data = {
                        localId: localId,
                        suc: function(res) {
                            self.$loading.close();
                            var serverId = res;
                            var item = { 'type': 'voice', 'name': "语音", 'localId': localId,'serverId': serverId, "time": self.time }
                            self.$emit("send_voice", item);
                            self.btn_close();
                        }
                }
                this.wxUploadVoice(data);

                //第二步：重置微信语音（比如正在播放语音的停止工作）
                this.reset_wx();
            },

            btn_cancel() {
                this.reset();
            },

            btn_close() {
               this.reset();
               this.$emit("close_voice");
            },

            stop_auto_send() {
                this.send_state = 0;
                clearTimeout(this.send_timeout);
            },

            reset() {
                this.touch_state = 0;
                this.play_voice_state = 0;
                this.time = 0;
                this.startTime = 0;
                this.$store.commit('set_objVal', {"voice_state":0});

                this.reset_wx();
            },

            reset_wx(){
                //停止播放
                if(this.localId){
                    this.wxStopVoice(this.localId);
                }
                //停止录音
                var data = {
                    suc: function(res) {}
                };
                this.wxStopRecord(data);
            },

            //权限相关--------start
            check_right() {
                var rtn = true;
                if (this.uinfo_from.vip_level == 0) {
                    //付金币提示
                    var voice_send_cointip = this.$store.state.objVal.voice_send_cointip;
                    if (!voice_send_cointip) {
                        this.show_payCoin_tip(); 
                    } else {
                        //金币检查
                        if (!this.check_coin(50)) {
                            return false;
                        }
                        this.sub_coin_sendVoice(50);
                    }
                   
                 return false;
                }
                return rtn;
            },
            //扣金币提示
            show_payCoin_tip() {
                var h = "<span style='text-align: left;'>发送语音需要会员权限，否则需要支付50金币/条,点击支付金币即可发送语音同时扣除50金币，本提示每天只进行一次，后续发送语音将默认扣除50金币。升级会员可免费发送语音。</span>";
                    this.$refs.myForm_sendVoice.show(h, {
                        type: "confirm",
                        confirmText: "升级会员",
                        cancelText: "支付金币",
                        titleText: "温馨提示",
                        data: "",
                });

                this.$store.commit('set_objVal', {"voice_send_cointip":true});
            },
            formact_sendVoice(type, data) {
                if (type == "clickConfirm") {
                    this.$router.push({ name: "vip_center" });
                }
                if (type == "clickCancel") {
                    //金币检查
                    if (!this.check_coin(50)) {
                        return false;
                    }
                    this.sub_coin_sendVoice(50);
                }
            },
            sub_coin_sendVoice(coin_sub) {
                var uid = this.$store.state.uid;
                var send_data = {
                    uid_from: uid,
                    uid_to: this.toUid,
                    amount: coin_sub,
                    type_dtl: "发送语音",
                    comment: "",
                };
                var self = this;
                self.act_sub_coin({
                    uid: uid,
                    strSend: JSON.stringify(send_data),
                    success: function (res) {
                    if (res.state == "1") {
                        //扣金币成功
                        self.uinfo_from.coin_left -= coin_sub;
                        self.do_send();
                    }
                    },
                });
            },
            check_coin(coin_pay) {
                var coin_left = this.uinfo_from.coin_left;
                if (coin_left < coin_pay) {
                    //提示金币不足
                    this.$refs.myConfirm_buyCoin.show("金币余额不足,请先充值哦", {
                    type: "confirm",
                    confirmText: "去购买",

                    titleText: "温馨提示",
                    data: "",
                    });
                    return false;
                } else {
                    return true;
                }
            },
            formact_buycoin(type, data) {
                if (type == "clickConfirm") {
                    this.$router.push({ name: "mycoin" });
                }
            },
            //权限相关--------end
            loading(title,time) {
            var self = this;
                this.$loading(title);
                setTimeout(() => {
                    self.$loading.close();
                }, time);
            }



            }
   }
</script>
<style lang="scss" scoped>
   .container {
        position: fixed;
        width: 100%;
        height: 25rem;
        text-align: center;
        bottom: 0;
        left: 50%;
        max-height: 100%;
        border-top-left-radius: 2rem;
        border-top-right-radius: 2rem;
        background-color: #333333eb;
        overflow-y: auto;
        transform: translate3d(-50%, 0, 0);
        backface-visibility: hidden;
        transition: transform .3s ease-out;
        overflow: hidden;
        .trumpet {
            width: 2rem;
            height: 2rem;
        }
   }
   .close-block {
    padding: 0.5rem 1rem;
    img {
        width: 2rem;
        height: 2rem;
    }
   }

   .ly-block {
    .yuyin-0 {
        margin-top: 1rem;
        width: 6rem;
        height: 6rem;
    }
    .yuyin-1 {
        position: relative;
        .wave {
            position: relative;
            width: 6rem;
            height: 6rem;
            border-radius: 50%;
            img {
                width: 8rem;
                height: 8rem;
            }
            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                width: 6rem;
                height: 6rem;
                background-color: #E8BBE2;
                border-radius: 50%;
                opacity: 0;
                transform: translate(-50%, -50%) scale(1);
                animation: pulse 1.5s ease-out infinite;
            }
        }

        @keyframes pulse {
            0% {
                opacity: 0.5;
                transform: translate(-50%, -50%) scale(1);
            }
            100% {
                opacity: 0;
                transform: translate(-50%, -50%) scale(2);
            }
        }
    }
   }

   .shuohua {
    span {
        font-size: 1rem;
        color: #888;
        user-select:none; //防止按住触发复制事件
    }
   }

   .pin-block {
    margin-top: 0.5rem;
    width: 100%;
    height: 7rem;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
    background: linear-gradient(to bottom, #FE9CC0, #A264E7);
    animation: borderColor 1.5s infinite;

    -webkit-touch-callout:none; /*系统默认菜单被禁用*/
    -webkit-user-select:none; /*webkit浏览器*/
    -khtml-user-select:none; /*早期浏览器*/
    -moz-user-select:none;/*火狐*/
    -ms-user-select:none; /*IE10*/
    user-select:none;
    img {
        margin-top: 2rem;
        width: 2rem;
        height: 2rem;
    }
   }

   @keyframes borderColor {
    0% {
        border-top: 3px solid #fff;
    }
    50% {
        border-top: 3px solid #FE9CC0;
    }
    100% {
        border-top: 3px solid #fff;
    }
    }

   .yuyin-block {
    margin-top: 2rem;
    width: 100%;
    .playVoice-block {
        width: 60%;
    }
    .play-voice {
        flex: 1;
        padding: 0 1rem;
        height: 4rem;
        background-color: #9ae6e2;
        border-radius: 0.5rem;
        span {
            margin-right: 0.5rem;
            font-size: 1.4rem;
        }
    }
    .play-voice-right {
      width: 0;
      height: 0;
      border-width: 0.8rem;
      border-style: solid;
      border-color: transparent transparent transparent #9ae6e2;
    }
    .play-tip {
        margin-top: 0.5rem;
        font-size: 0.9rem;
        color: #888;
    }
   }

   .btn-block {
    width: 100%;
    height: 5rem;
    .btn {
        margin-bottom: 5rem;
        width: 4rem;
        height: 4rem;
        border-radius: 50%;
        span {
            color: #fff;
            font-size: 0.9rem;
        }
    }
    .cancel {
        background-color: red;
        img {
            width: 3rem;
            height: 3rem;
        }
    }
    .send {
        img {
            width: 100%;
            height: 100%;
        }
    }
    // .auto-send {
    //     background-color: #fff;
    //     animation: slideUp 5s infinite;
    //     img {
    //         width: 2.5rem;
    //         height: 2.5rem;
    //     }
    // }
    // @keyframes slideUp {
    //     0% {
    //         background: #fff;
    //     }
    //     20% {
    //         background: linear-gradient(to top, #68D279 0.5rem, #fff);
    //     }
    //     40% {
    //         background: linear-gradient(to top, #68D279 1rem, #fff);
    //     }
    //     60% {
    //         background: linear-gradient(to top, #68D279 1.5rem, #fff);
    //     }
    //     80% {
    //         background: linear-gradient(to top, #68D279 2rem, #fff);
    //     }
    //     100% {
    //         background: #68D279;
    //     }
    // }

    .auto-send {
        position: relative;
        width: 4rem;
        height: 4rem;
        border-radius: 50%;
        overflow: hidden;
        background: #fff;
        img {
            width: 2.5rem;
            height: 2.5rem;
            z-index: 2;
        }
    }

    .auto-send::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0;
        background: #68D279;
        animation: fillWater 5s infinite;
    }

    @keyframes fillWater {
        0% {
        height: 0;
        }
        25% {
        height: 25%;
        }
        50% {
        height: 50%;
        }
        75% {
        height: 75%;
        }
        100% {
        height: 100%;
        }
    }

   }
   

/*弹窗动画*/
.ryt-transition-enter,
.ryt-transition-leave-active {
   transform: translate3d(-50%, 100%, 0);
   transition: transform 0.6s ease-in-out;
}    
</style>
